var exports = {
  "k": "x93eb46d8--79b66b--container",
};

module.exports = exports;
